<template>
  <div id="object-links-list" >
    <b-card
        :header="list_header"
        header-tag="h4"
        bg-variant="light"
    >
      <b-button-group v-if="mode_switch" size="sm" class="mb-3" id="tourists-mode-switch">
        <b-button
            :variant="group_mode ? 'outline-secondary' : 'secondary'"
            @click="switch_mode('personal')"
        >Персональный</b-button>
        <b-button
            :variant="group_mode ? 'secondary' : 'outline-secondary'"
            @click="switch_mode('group')"
        >Групповой</b-button>
      </b-button-group>

      <b-row v-if="group_mode">
        <b-col cols="3">
          <autosave-input
              :params="group_size_input"
              :value="order.group_size"
              :id="order_id"
              record_type="order"
              :url="order_url"
              @on_save="on_group_saved"
          ></autosave-input>
        </b-col>
        <b-col>
          <autosave-input
              :params="group_comment_input"
              :value="order.group_comment"
              :id="order_id"
              record_type="order"
              :url="order_url"
              @on_save="on_group_saved"
          ></autosave-input>
        </b-col>
      </b-row>

      <template v-if="!group_mode && show_list">
        <component v-for="(link, index) in links"
                   v-bind:is="used_component"
                   v-bind="link.attributes"
                   :objects="objects"
                   :lang="lang"
                   :key="index"
                   :index="index"
                   :role="role"
                   @delete_click="delete_link"
                   @save="on_save"
        ></component>
      </template>

      <template v-slot:footer v-if="!group_mode">
        <b-button
            v-if="can_add_link"
            size="sm"
            @click="add_link"
        >
          Выбрать
        </b-button>
        <b-button
            v-if="can_add_link"
            size="sm"
            @click="open_modal"
            variant="outline-secondary"
        >
          Создать нового
        </b-button>
      </template>
    </b-card>
    <modal title="Новый турист"
           :show="show_modal"
           v-on:modal_hide="show_modal = false"
           v-on:modal_show="show_modal = true"
    >
      <template v-slot:default>
        <CustomerForm
            v-if="show_modal"
            action="new"
            :role="role"
            :order_id="order_id"
            @submit_ok="add_customer"
        >
        </CustomerForm>
      </template>

    </modal>

  </div>
</template>

<script>
  import BaseLinkListStore from "../shared/BaseLinkListStore";
  import CustomerOrderItem from "./CustomerOrderItem";
  import CustomerOrderItemRO from "./CustomerOrderItemRO";
  import Modal from "../Modal";
  import CustomerForm from "./CustomerForm";
  import AutosaveInput from "../base/AutosaveInput";
  import {show_api_error} from "../shared/api_errors";
  export default {
    name: 'CustomerOrderList',
    extends: BaseLinkListStore,
    components: {CustomerForm, Modal, CustomerOrderItem, CustomerOrderItemRO, AutosaveInput },
    props: {
      lang: String,
      order_id: Number,
      mode_switch: {
        type: Boolean,
        default: false,
      },
      role: {
        type: String,
        default: 'user',
      }
    },
    data() {
      let module_name = 'orders';
      if (this.role == 'agent') module_name = 'agents';
      if (this.role == 'client') module_name = 'clients';

      return {
        module_name,
        log: true,
        // set child component - List Item
        item_component: 'CustomerOrderItem',
        ro_item_component: 'CustomerOrderItemRO',
        list_header: 'Туристы',

        objects_getter:     `${module_name}/allCustomers`,
        // set undefined because objects sets in get_links_action
        get_objects_action: undefined, // 'orders/getCustomers'
        get_links_action:   `${module_name}/getCustomerOrders`,
        get_links_payload: {
          order_id: this.order_id,
        },
        delete_link_action: `${module_name}/deleteCustomerOrder`,

        // set urls for api requests
        // url_links: '/customer_orders',
        // url_objects: '/customers',

        // set field name for composing collection
        // text_field_for_collection: 'name',

        // set a scaffold for new_link object
        new_link: {
          id: undefined,
          attributes: {
            id: undefined,
            customer_id: undefined,
            order_id: this.order_id,
          }
        },
        show_always: true,
        show_modal: false,
      }
    },

    computed: {
      // replaced original method
      stored_links() {
        return this.$store.state[this.module_name].customer_orders;
      },
      order() {
        return this.$store.state[this.module_name].order;
      },
      order_url() {
        return `/orders/${this.order_id}`;
      },
      group_mode() {
        return this.mode_switch && this.order.tourists_mode === 'group';
      },
      group_size_input() {
        return {
          value: this.order.group_size,
          field: 'group_size',
          label: 'Количество человек',
          type: 'number',
          mode: 'input',
          required: true,
          has_error: false,
          error_hint: null,
        };
      },
      group_comment_input() {
        return {
          value: this.order.group_comment,
          field: 'group_comment',
          label: 'Комментарий',
          type: 'text',
          mode: 'input',
          has_error: false,
          error_hint: null,
        };
      },
    },
    methods: {
      switch_mode(mode) {
        if (mode === (this.group_mode ? 'group' : 'personal')) return;

        if (mode === 'group' && this.stored_links.length > 0) {
          this.$bvToast.toast('Чтобы перейти на групповой состав, сначала открепите туристов.', {
            title: 'Переключение невозможно',
            variant: 'warning',
            toaster: 'b-toaster-bottom-right',
            solid: true,
            autoHideDelay: 8000,
          });
          return;
        }

        let vc = this;
        $.ajax({
            url: this.order_url,
            type: 'PATCH',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify({order: {tourists_mode: mode}}),
          })
          .done(function (data) {
            vc.$store.dispatch(`${vc.module_name}/setOrder`, data.data.attributes);
          })
          .fail(function (jqXHR) { show_api_error(vc, jqXHR); });
      },

      on_group_saved(item) {
        this.$store.dispatch(`${this.module_name}/setOrder`, item.attributes);
      },

      open_modal() {
        this.show_modal = true;
      },

      // add customer to store lists.
      // create customer_order for this customer
      add_customer(customer) {
        let customer_order_payload = {
          customer_id: customer.id,
          order_id: this.order_id,
        };

        this.$store.dispatch(`${this.module_name}/addCustomerOrder`, customer_order_payload);
        // предложенная вместо дубля карточка уже может быть в списке — второй раз не добавляем
        let known = this.$store.state[this.module_name].customers.some(c => c.id == customer.id);
        if (!known) this.$store.commit(`${this.module_name}/addCustomer`, customer);
        this.show_modal = false;
      }
    }
  }
</script>